import { render } from "./Footer.vue?vue&type=template&id=a3f55bb4&bindings={}"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
script.render = render

export default script